import { createFileRoute } from "@tanstack/react-router";

import { HeroBuildsPage, heroBuildsSearchSchema } from "@/features/builds";

// «Сборки»: экран целиком из фичи `builds`. Выбранный герой — в search params, меняется
// без новой записи в истории браузера и без прокрутки наверх.
const BuildsRoute = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <HeroBuildsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
};

export const Route = createFileRoute("/builds")({
  validateSearch: heroBuildsSearchSchema,
  component: BuildsRoute,
});
